import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import {NzMessageService} from 'ng-zorro-antd/message';
import {TaskService} from '../../../services/task.service';
@Component({
  selector: 'app-table-view-abstract',
  templateUrl: './table-view-abstract.component.html',
  styleUrls: ['./table-view-abstract.component.css']
})
export class TableViewAbstractComponent implements OnInit {
  dataSubscription: Subscription = null;
  columnData: any;
  groupData: any;
  renderBoard: any;
  taskList: Array<any> = [];
  boardColumnData: Array<any> = [];
  clickCurrentColumnValue = null; // 是否点击当前列
  isMemberVisible = false; // 选择成员
  currentColumnData: any; // 存放当前列数据
  permissionDefinition: any;
  originalValue: string;
  // 批量设置成员
  isBatchAddMemberVisible = false;
  batchAttachMemberVisible = false;
  currentColumnId = ''; // 当前列ID
  selectedMemberValue: Array<any> = [];
  selectedTaskValue: Array<any> = [];
  currentUser: any; // 存放当前用户信息
  isLoading: boolean;
  total: number;
  pageIndex = 1;
  pageSize = 999;
  searchKey;
  getBoardUserList: Observable<any>;
  loadMoreData = true;
  memberList: Array<any> = [];
  randomUserUrl: string;
  boardId: string;
  isBatchAddMemberLoading = false;
  isConfirmLoading = false; // 批量修改弹窗提交按钮状态
  buttonConfigStatus = true; // 按钮配置项显示状态
  buttonConfigTitle = null; // 按钮配置-标题
  buttonConfigDisabled = true; // 按钮配置-是否可用
  buttonConfigUrl = null; // 按钮配置-url
  buttonConfigEditStatus = false; // 按钮配置-是否编辑状态
  buttonConfigEditeData: any = {}; // 按钮配置-存放当前编辑项数据
  clickButtonLoading: boolean; // 按钮配置 - 按钮loading
  @Input('column') set ChangeColumn(data: any) {
    this.columnData = data;
    this.originalValue = this.columnData.title;
  }
  @Input('boardId') set ChangeBoardId(data: any) {
    this.boardId = data;
  }
  @Input('group') set ChangeGroup(data: any) {
    this.groupData = data;
  }
  @Input('currentUser') set ChangeCurrentUser(data: any) {
    this.currentUser = data;
  }
  @Input('permissionDefinition') set ChangePermission(data: any) {
    this.permissionDefinition = data;
  }
  @Input('renderBoard') set ChangeRenderBoard(data: any) {
    this.renderBoard = data;
    this.taskList = JSON.parse(JSON.stringify(data));
    this.taskList = this.taskList.filter(d => d.isColumn !== true);
    this.taskList = this.taskList.filter(d => d.isFooter !== true);
  }
  @Output() nfColumnChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    public message?: NzMessageService,
    public taskService?: TaskService,
  ) { }
  @HostListener('window:click', ['$event'])
  handleClick(e: MouseEvent): void {
    if (this.clickCurrentColumnValue && this.hasClass(e.target, 'cdk-overlay-backdrop cdk-overlay-dark-backdrop')) {
      this.clickCurrentColumnValue = null;
    }
  }
  ngOnInit(): void {
  }
  modifyColumnName(title, boardId, groupId, color) {
    const param = {
      title: title,
      color: color
    };
    if (this.originalValue !== title) {
      this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {
        this.originalValue = res.title;
      });
    }
  }
  // 修改列头
  modifyColumnHeader(title, boardId, columnId) {
    const param = {
      title: title
    };
    if (this.originalValue !== title) {
      this.dataSubscription = this.taskService.doEditColumnHeader(boardId, columnId, param).subscribe((res: any) => {
        this.originalValue = res.title;
      });
    }
  }
  // 删除列
  removeColumn(boardId, columnId) {
    const param = {
      'destroy': true
    };
    this.dataSubscription = this.taskService.doDeleteColumn(boardId, columnId, param).subscribe((res: any) => {
      const status = {
        event: 'removeColumn',
        status: true,
        date: this.columnData
      };
      this.nfColumnChange.emit(status);
    });
  }
  // 列权限控制
  columnPermissionSet(type, columnId, state) {
    const param = {};
    param[type] = state;
    if (type === 'lock') {
      this.dataSubscription = this.taskService.setLockState(this.groupData.boardId, columnId, param).subscribe((res: any) => {
        this.handleColumnPermission(type, columnId, state);
      });
    } else if (type === 'hide') {
      this.dataSubscription = this.taskService.setHideState(this.groupData.boardId, columnId, param).subscribe((res: any) => {
        this.handleColumnPermission(type, columnId, state);
      });
    }
  }
  // 处理列权限
  handleColumnPermission(type, columnId, state) {
    this.columnData.permissionType = state === 'false' ? null : type;
    this.columnData.permittedUserIds = [];
    this.boardColumnData.forEach((item, index) => {
      if (item.id === columnId) {
        this.boardColumnData[index].permissionType = state === 'false' ? null : type;
        this.boardColumnData[index].permittedUserIds = [];
      }
    });
  }
  // 列加密状态切换
  columnEncryptChange(column) {
    let state = null;
    if (!column.encrypt) {
      state = 'true';
    }
    if (column.encrypt === 'true') {
      state = 'false';
    } else if (column.encrypt === 'false') {
      state = 'true';
    }
    this.handleColumnEncrypt(column.id, state);
  }
  // 列加密数据处理
  handleColumnEncrypt(columnId, state) {
    this.boardColumnData.forEach((item, index) => {
      if (item.id === columnId) {
        item.encrypt = state;
      }
    });
    this.columnData.encrypt = state;
    const param = {
      'encrypt': state
    };
    this.dataSubscription = this.taskService.setColumnEncrypt(this.groupData.boardId, columnId, param).subscribe((res: any) => {
      this.message.create('success', '设置成功！');
    });
  }
  // 点击当前列显示状态切换
  clickCurrentColumn(columnId, groupId) {
    this.clickCurrentColumnValue = columnId + groupId;
  }
  // hasClass
  hasClass(elem, className) {
    const reg = new RegExp('(^|\\s+)' + className + '($|\\s+)');
    return reg.test(elem.className);
  }
  // 成员选择
  columnSelectMember(column) {
    this.isMemberVisible = true;
    this.currentColumnData = column;
  }
  handleMemberCancel() {
    this.isMemberVisible = false;
    this.currentColumnData = null;
  }
  // 批量设置成员
  batchSettingMember(columnId) {
    this.currentColumnId = columnId;
    this.isBatchAddMemberVisible = true;
    this.selectedMemberValue = [];
    this.selectedTaskValue = [];
    this.onMemberSearch('');
    if (this.currentUser) {
      this.selectedMemberValue = [...this.selectedMemberValue, this.currentUser];
    }
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.groupData.boardId, param).subscribe((res: any) => {
      if (res) {
        this.memberList = res.users ? res.users.data : [];
        this.isLoading = false;
        this.pageIndex = res.users.page.number + 1;
      }
    });
  }
  handleBatchAddMemberCancel() {
    this.isBatchAddMemberVisible = false;
  }
  handleBatchAttachOk() {
    const changeValues = [];
    this.selectedTaskValue.forEach(taskId => {
      this.renderBoard.forEach(item => {
        if (item.id === taskId) {
          if (item.columnValues[this.currentColumnId]) {
            if (item.columnValues[this.currentColumnId].personsAndTeams) {
              item.columnValues[this.currentColumnId].personsAndTeams.push(...this.selectedMemberValue);
              const obj = {};
              item.columnValues[this.currentColumnId].personsAndTeams =
                item.columnValues[this.currentColumnId].personsAndTeams.reduce((cur, next) => {
                obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
                return cur;
              }, []);
            } else {
              item.columnValues[this.currentColumnId].personsAndTeams = this.selectedMemberValue;
            }
            changeValues.push({
              pulseIds: [taskId],
              columnId: this.currentColumnId,
              columnValue: item.columnValues[this.currentColumnId]
            });
          }
        }
      });
    });
    if (changeValues.length > 0) {
      this.batchUpdateBoardMember(this.groupData.boardId, changeValues);
    }
  }
  // 批量更新人员请求
  batchUpdateBoardMember(boardId, param) {
    this.taskService.batchAttachUser(boardId, param).subscribe(res => {
      if (res) {
        this.message.success('设置成功');
      } else {
        this.message.success('设置失败');
      }
      this.isBatchAddMemberVisible = false;
    });
  }
  // 按钮组件事件
  // 按钮组件-配置关联
  buttonRelationChange(event, column) {
    column.config.relation = event;
    const param = {
      'config': column.config
    };
    this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe((res: any) => {});
  }
  buttonSelectChange(event, pulseId, column) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = {
      'original': event
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  // 按钮组件-自定义按钮点击事件
  buttonCustomClick(column, pulse) {
    let url = '';
    column.config.original.forEach((item, index) => {
      if (item.id.toString() === pulse.columnValues[column.id].original.toString()) {
        url = item.url;
      }
    });
    const param = {
      'pulseId': pulse.id,
      'columnId': column.id
    };
    this.clickButtonLoading = true;
    this.dataSubscription = this.taskService.buttonClickEvent(url, param).subscribe((res: any) => {
      this.nfColumnChange.emit(true);
      this.clickButtonLoading = false;
    }, (err) => {
      this.clickButtonLoading = false;
    });
  }
  // 按钮组件-关联按钮点击事件
  buttonRelationClick(url, pulseId) {
    // todo 后台交互
    console.log(url + pulseId)
  }
}
